import { basicAccountInfo } from "api/basic_account_info";
import { generic_get_api, generic_put_api } from "api/generic_api";
import { Component } from "react";
import { Button, Form } from 'react-bootstrap';
import { CODE_SECTIONS } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';
import { SfUseDistrict, Topics } from 'utils/sf_code_constants';


class CodeSections extends Component {

    constructor(props) {
        let section_id = null;

        let urlParams = new URLSearchParams(window.location.search);
        section_id = urlParams.get('section_id');


        super(props);

        this.state = {
            section_id: section_id,
            parts: [],
            session_ok: false,
            working: false,
        };
        this.fetchCodeParts = this.fetchCodeParts.bind(this);
    }

    fetchCodeParts() {
        this.setState({working: true });

        generic_get_api(CODE_SECTIONS, {section: this.state.section_id})
        .then(
            data => { 
                this.setState({
                    parts: data.section_parts,
                    section_title: data.section_title,
                    display_section_id: data.section_id,
                    official_url: data.official_url,
                    working: false,
                })
            }
        )
        .catch(error => {
        });
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {'data_1': 'code_parts'});
        basicAccountInfo()
        .then(
            data => {
                this.setState({session_ok: true });

                if (this.state.section_id) {
                    this.fetchCodeParts();
                }
            }
        ).catch(error => {
            if (error?.name === 'LOGIN_ERROR') {
                this.props.history.push('/login');
            }
        });

    }

    render() {
        const {parts, working, section, display_section_id, section_title, official_url} = this.state;
        

        const getMargin = (part) => {

            if(part.level === 1){
                return "row margin_subsection_1";
            }
            else if(part.level === 2){
                return "row margin_subsection_2";
            }
            else if(part.level === 3){
                return "row margin_subsection_3";
            }
            else if (part.level === 4) {
                return "row margin_subsection_4";
            }
            else if (part.level === 5) {
                return "row margin_subsection_5";
            }
            else {
                return "row";
            }
        }

        const getTableRowStyling = (row) => {
            if (row.is_header) {
                return "row fw-semibold bg-light bottom_border p-1";
            }
            else {
                return "row bottom_border p-1";
            }
        }

        return(
            <div class="container-fluid codeSections ps-4">
                {/* {this.state.session_ok && 
                    <div class="row">
                        <div class="col-auto me-3">
                            <input type="text" class="form-control" value={section} placeholder="section" onChange={(e) => this.setState({section: e.target.value})}/> 
                            
                        </div>
                        <div class="col-auto me-3 text-start"><Button variant="secondary" onClick={ this.resetEverythingAndFetch }>OK</Button></div>
                    </div>
                } */}

                {
                    working && 
                    <div class="container mt-5 text-center">
                        <span class="spinner-border" aria-hidden="true"></span>
                    </div>
                }
                
                {  
                    <div class="container">  
                        {
                            display_section_id && section_title &&
                            <div class="row mt-5">
                                <div class="row mt-2">
                                    <div class="col fs-5 fw-bold">SEC. {display_section_id} {section_title}&nbsp;
                                        <a target="_blank" href={official_url}><i class="fa-solid fa-arrow-up-right-from-square"></i></a></div>
                                </div>
                            </div>
                        }
                        

                        {parts.map((part, index) => {
                            if (part.type === 'section' && part.order !== 0) {
                                return <div class="row mt-1">
                                            <div class="row mt-2">
                                                <div class="col">
                                                    <div class={getMargin(part)}>
                                                        {
                                                            part.level === 0 ? 
                                                            <>
                                                                <div class="col">{part.text}</div>
                                                            </>
                                                            :
                                                            <>
                                                                { part.subsection ?
                                                                    <>
                                                                        {part.level < 4?
                                                                            <div class="col-1 pe-0 ps-0 subsection">({part.subsection})</div> 
                                                                            :
                                                                            <div class="col-1 pe-0 ps-0 subsection">{part.subsection}.</div>
                                                                        }
                                                                    </>
                                                                    
                                                                    :
                                                                    <div class="col-1 pe-0 ps-0 subsection">&nbsp;&nbsp;&nbsp;</div>
                                                                }
                                                                
                                                                <div class="col">{part.text}</div>
                                                            </>
                                                        
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>  
                            }
                            if (part.type === 'table') {
                                return <div class="container mt-5 sectionTable">
                                            {
                                                (part.table_number || part.table_title) &&
                                                <div class="row mt-2 mb-3 fw-bold text-center">
                                                    <>{part.table_number && <div class="me-2">Table {part.table_number}</div>}</>
                                                    <>{part.table_title && <div class="col">{part.table_title}</div>}</>
                                                </div>
                                            }
                                            <div class="container border rounded">
                                                {
                                                    part.rows.map(row=>{
                                                        return  <div class={getTableRowStyling(row)}>
                                                                    {
                                                                        row.columns.map(col => {
                                                                            if (col) {
                                                                                return <div class="col text-center">{col}</div>
                                                                            }
                                                                            
                                                                        })
                                                                    }
                                                                </div>
                                                    })
                                                }
                                            </div>
                                            {
                                                part.foot_notes && part.foot_notes.length > 0 && 
                                                <div class="container mt-2">
                                                {
                                                    part.foot_notes.map(foot_note => {
                                                        return  <div class="row">
                                                                    <div class="col"><i class="fa-regular fa-note-sticky fa-sm"></i>&nbsp;<small>{foot_note}</small></div>
                                                                </div>
                                                    })
                                                }
                                                </div>
                                            }
                                           
                                        </div>  
                            }
                            if (part.type === 'image') {
                                return <div class="container mt-3">
                                            <div class="row mt-2 mb-3 text-center">
                                                <div class="col"><img src={part.url}/></div>
                                            </div>
                                        </div>  
                            }
                        })}
                    </div>
                }
              
            </div>
        )
    }
}

export default CodeSections;